import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';

export default function IndexDynamic() {
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <EmailSubscribe locale="jp" className="email-subscribe" pageType={PAGE_TYPE.Camp} entry_position={6} />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
        </>
    );
}
